import type { StorefrontAdapter } from '../types';

declare global {
  interface Window {
    StampedFn?: {
      init?: (opts: { apiKey: string; sId: string }) => void;
      reloadUGC?: () => void;
      loadBadges?: () => void;
      loadDisplayWidgets?: () => void;
    };
  }
}

let initialised = false;
let pendingInit: { apiKey: string; sId: string } | null = null;

function init(): void {
  if (initialised || !pendingInit || typeof window === 'undefined' || !window.StampedFn?.init) return;
  window.StampedFn.init(pendingInit);
  initialised = true;
}

/**
 * Stamped.io widget loader: widget.min.js then `StampedFn.init({ apiKey, sId })`
 * with the PUBLIC key and store hash. Elements rendered later (SPA routes)
 * are picked up by `reloadUGC` / `loadBadges`.
 */
export const stampedAdapter: StorefrontAdapter = {
  id: 'stamped',
  isConfigured: (cfg) =>
    typeof cfg.public_key === 'string' && cfg.public_key.length >= 8 && typeof cfg.store_hash === 'string' && /^[A-Za-z0-9_-]{4,64}$/.test(cfg.store_hash),
  load(cfg) {
    if (typeof document === 'undefined') return;
    pendingInit = { apiKey: cfg.public_key, sId: cfg.store_hash };
    const existing = document.getElementById('stamped-widget');
    if (existing) {
      init();
      return;
    }
    const s = document.createElement('script');
    s.id = 'stamped-widget';
    s.src = 'https://cdn1.stamped.io/files/widget.min.js';
    s.async = true;
    s.onload = init;
    document.head.appendChild(s);
  },
  refresh() {
    if (!initialised) {
      init();
      return;
    }
    window.StampedFn?.reloadUGC?.();
    window.StampedFn?.loadBadges?.();
  },
};

/** Test seam. */
export function _resetStampedAdapterForTests(): void {
  initialised = false;
  pendingInit = null;
}
